/* eslint-disable max-len */
/* eslint-disable no-useless-constructor,react/destructuring-assignment */
// Copyright (c) 2023 Deere & Company

// import './pin-search.scss';

import React, { Component } from 'react';
import BusyCounterLoadingIndicator from '../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import DuplicatePinPlateList from './duplicate-pin-plate-list';
import DuplicatePinPlateView from '../state/duplicate-pin-plate-view';
import { FormattedMessage } from 'react-intl';
import NumberOfRecordsFound from '../../../sharedmodules/components/number-of-records-found';
import PropTypes from 'prop-types';

class DuplicatePinPlateSettings extends Component {

    constructor(props) {

        super(props);

    }

    componentWillMount() {

        this.props.actions.readDuplicatePinPlate(this.props.auth.getAccessToken);

    }

    componentWillUnmount() {

        this.props.actions.resetDuplicatePinPlate();

    }

    render() {

        const { busyCounter } = this.props;

        return (
            <section className="dealer-settings">
                <section className="dealer-settings-panel">
                    <BusyCounterLoadingIndicator busyCounter={busyCounter} />
                    <div className="dealer-settings-header">
                        <h5>
                            <FormattedMessage id="DUPLICATE_PIN_PLATE" />
                        </h5>
                    </div>
                </section>
                <section>
                    {this.props.duplicatePinPlateChanges.length ? (

                        <>
                            <div>
                                {this.props.duplicatePinPlateChanges[0].pin !== '' ?
                                    <NumberOfRecordsFound count={this.props.duplicatePinPlateChanges.length} />
                                    : null}

                            </div>
                            <DuplicatePinPlateList
                                actions={this.props.actions}
                                auth={this.props.auth}
                                duplicatePinPlateChanges={this.props.duplicatePinPlateChanges}
                            />

                        </>

                    ) : <span className="empty"><FormattedMessage id="NO_RESULTS_FOUND" /></span>}
                </section>
            </section>
        );

    }

}

DuplicatePinPlateSettings.displayName = 'DuplicatePinPlateSettings';
DuplicatePinPlateSettings.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    duplicatePinPlateChanges: PropTypes.arrayOf(PropTypes.instanceOf(DuplicatePinPlateView)).isRequired,
    busyCounter: PropTypes.bool.isRequired,
};

export default DuplicatePinPlateSettings;
